"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _TableRow = _interopRequireDefault(require("@mui/material/TableRow/TableRow"));
var _fonts = _interopRequireDefault(require("../theme/fonts"));
var _colors = _interopRequireDefault(require("../theme/colors"));
var _system = require("@mui/system");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 
 * @param {*} props 
 * @returns 
 */
var StyledTableRow = function StyledTableRow(props) {
  var theme = (0, _system.useTheme)();
  var style = _objectSpread({
    "&.MuiTableRow-head": {
      background: "linear-gradient(to right, ".concat(theme.palette.primary.main, " 0%, ").concat(theme.palette.primary.main, " 100%)"),
      borderTop: "2px solid ".concat(theme.palette.whitelabel.buttonTextColor),
      color: theme.palette.whitelabel.buttonTextColor,
      fontFamily: _fonts["default"].type.heading,
      fontSize: _fonts["default"].size.medium
    },
    "&.MuiTableRow-root": {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.whitelabel.buttonTextColor,
        "&:hover": {
          backgroundColor: _colors["default"].lightHoverGrey
        }
      },
      backgroundColor: _colors["default"].backgroundGrey
    }
  }, props.style);
  return /*#__PURE__*/_react["default"].createElement(_TableRow["default"], (0, _extends2["default"])({
    sx: style
  }, props), props.children);
};
var _default = exports["default"] = StyledTableRow;